var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    { attrs: { hasData: !!_vm.clients, loading: _vm.loading } },
    [
      _c(
        "div",
        [
          _c("ClientsVisitsCollectionFilters", {
            attrs: {
              currentUserId: _vm.currentUser?.id,
              currentUserRole: _vm.currentUser?.role,
              filters: _vm.projectFilters,
              isDateOffered: true,
              hideContractorsFilter: "",
              hideBudgetFilter: "",
            },
            on: {
              filtersChanged: _vm.updateFilters,
              filtersReset: _vm.resetFilters,
            },
          }),
          _c("p", { staticClass: "mb-6 text-sm font-normal" }, [
            _vm._v(" " + _vm._s(_vm.totalCount) + " Total offered visits "),
          ]),
          _c(
            "div",
            {
              staticClass:
                "mb-8 flex warningText flex-row justify-between w-full",
            },
            [
              _c("div", { staticClass: "flex flex-row" }, [
                _c(
                  "div",
                  {
                    staticClass: "mt-1 h-4 w-auto",
                    attrs: { alt: "delete notes" },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 16 16",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("g", { attrs: { id: "Icon / InfoCircleFilled" } }, [
                          _c("path", {
                            attrs: {
                              id: "Vector",
                              d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8.5 11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V7.125C7.5 7.05625 7.55625 7 7.625 7H8.375C8.44375 7 8.5 7.05625 8.5 7.125V11.375ZM8 6C7.80374 5.99599 7.61687 5.91522 7.47948 5.775C7.3421 5.63478 7.26515 5.4463 7.26515 5.25C7.26515 5.0537 7.3421 4.86522 7.47948 4.725C7.61687 4.58478 7.80374 4.50401 8 4.5C8.19626 4.50401 8.38313 4.58478 8.52052 4.725C8.6579 4.86522 8.73485 5.0537 8.73485 5.25C8.73485 5.4463 8.6579 5.63478 8.52052 5.775C8.38313 5.91522 8.19626 5.99599 8 6Z",
                              fill: "#070823",
                            },
                          }),
                        ]),
                      ]
                    ),
                  ]
                ),
                _c("p", { staticClass: "child ml-2" }, [
                  _vm._v(" " + _vm._s(_vm.getCheckInMessage()) + " "),
                ]),
              ]),
            ]
          ),
          _vm.empty
            ? _c("EmptyListPlaceholder", {
                attrs: { title: _vm.emptyListMessage },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "image",
                      fn: function () {
                        return [_c("EmptyListImageProjects")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4049957145
                ),
              })
            : _c(
                "div",
                { staticClass: "mb-4 flex flex-wrap gap-4" },
                _vm._l(_vm.clients, function (client) {
                  return _c("ClientsVisitsCard", {
                    key: client.id,
                    attrs: {
                      projectDetailsRoute:
                        _vm.routeNames.CONTRACTOR_PROJECT_ACTIVITY,
                      client: client,
                      currentUser: _vm.currentUser,
                      isWithActivities: "",
                      hideDescription: "",
                    },
                  })
                }),
                1
              ),
        ],
        1
      ),
      _c("CardPagination", {
        attrs: { config: _vm.paginationConfig },
        on: {
          "update:config": function ($event) {
            _vm.paginationConfig = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }